module.exports = __webpack_public_path__ + "static/media/placeholder.e434a4de.svg";